// Thème PCC + helpers partagés par les blocs Puck.
//
// SOURCE PARTAGÉE (dépôt canonique pcc-puck-blocks). Copie « vendue » dans
// l'app (pccapp) et l'intranet (pcc-bureau). Ne jamais éditer les copies :
// modifier ICI puis `npm run sync-puck-blocks` dans chaque dépôt.
//
// Couleurs en inline styles (pas de classe Tailwind) pour un rendu identique
// quel que soit l'environnement.
export const PCC = {
  gold: '#D7A072',   // pcc-warm
  blue: '#4E7EA9',   // pcc-blue
  cream: '#F2F1EB',  // pcc-cream
  sand: '#E3E1CF',   // pcc-sand
  charcoal: '#272727', // pcc-charcoal
  violet: '#9398DE', // pcc-violet
  green: '#7BA88F',
  red: '#8B2635',
};

// Surfaces neutres qui BASCULENT selon le thème de l'app (clair/sombre).
// Les ACCENTS (gold/blue/violet, couleurs de type, couleurs choisies par
// l'éditrice) ne changent pas — seuls le fond des cartes, le texte de base et
// les encadrés internes s'inversent. `text` est une couleur de base à laquelle
// on ajoute des suffixes d'opacité (ex. `${s.text}CC`).
export function surface(theme) {
  const dark = theme === 'dark';
  return {
    page: dark ? '#171614' : '#FFFFFF', // fond de la page /page/:slug
    card: dark ? '#26241F' : PCC.cream, // fond des cartes
    inner: dark ? '#1B1A16' : '#FFFFFF', // encadrés internes (ex. IBAN)
    text: dark ? '#F2F1EB' : PCC.charcoal, // texte de base (+ suffixes d'opacité)
  };
}

// Date ISO (YYYY-MM-DD) → « dimanche 20 juillet 2026 ». Renvoie la valeur brute
// si non parsable, '' si vide.
export function frenchDate(iso, opts = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString('fr-FR', opts);
}
